export const fundsComparatorMaxVisibleProducts = 4;
export const fundsComparatorIndexes = [
  {
    name: 'CDI',
    id: 'cdi',
    color: 'feedback.error.default',
  },
  {
    name: 'IBOC',
    id: 'ibovespa',
    color: 'feedback.error.default',
  },
  {
    name: 'PTax',
    id: 'ptax',
    color: 'feedback.error.default',
  },
  {
    name: 'IMA-Btotal',
    id: 'imabtotal',
    color: 'feedback.error.default',
  },
];

export const fundsComparatorIndexesById: Record<
  (typeof fundsComparatorIndexes)[number]['id'],
  (typeof fundsComparatorIndexes)[number]
> = fundsComparatorIndexes.reduce((acc, index) => {
  acc[index.id] = index;
  return acc;
}, {} as any);

export const fundsComparatorAvailablePeriods = [
  {
    label: '1 ano',
    value: 12,
  },
  {
    label: '2 anos',
    value: 24,
  },
  {
    label: '3 anos',
    value: 36,
  },
];

export const fundsComparatorIndexesColors = ['#0F80ED', '#27AE60', '#9B51E0', '#EB5757', '#F2C94C'];

export const fundsComparatorProductsColors = [
  '#2F80ED',
  '#27AE60',
  '#9B51E0',
  '#EB5757',
  '#F2C94C',
  '#6C6C6C',
  '#BDBDBD',
  '#333333',
  '#56CCF2',
  '#828282',
  '#F2C94C',
  '#6C6C6C',
  '#BDBDBD',
  ...Array.from({ length: 10 }, () => '#CCCCC'),
];
